import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Layout from "../components/common/Layout";
import Home from "../pages/Home/Home";
import ThankYou from "../pages/ThankYou/ThankYou";
import PaymentMethod from "../pages/Payment/PaymentMethod";
import Candidates from "../pages/Hiring/Candidates";
import CandidatesSelected from "../pages/Hiring/CandidatesSelected";
import AdminLogin from "../pages/Admin/AdminLogin";
import AdminDashboard from "../pages/Admin/AdminDashboard";
import usePageTracking from "../components/steps/functions/PageTracking";
import RecordVideo from "../components/steps/RecordVideo/RecordVideo";
import UploadVideo from "../components/steps/UploadVideo/UploadVideo";
import SubmissionComplete from "pages/ThankYou/SubmissionComplete";
import Applicants from "pages/Admin/Applicants";
import ApplicantProfilePage from "pages/Admin/ApplicantProfilePage";
import MeetingWorkflow from "../pages/Hiring/MeetingWorkflow/ScheduleMeeting";
import PersistMeeting from "../pages/Hiring/MeetingWorkflow/PersistMeeting";

import SignUpPage from "../pages/Auth/SignUp";
import PhoneVerification from "../pages/Auth/Otp";
import PricingPage from "../pages/Hiring/Pricing";
import PaymentPage from "../pages/Hiring/Payment";
import PositionListing from "pages/ApplyForWork/PositionListing";
import SignInPage from "pages/Auth/SignIn";
import MeetingListPage from "pages/Hiring/MeetingListPage";
import PositionsPage from "pages/Hiring/Positions";
import EmployerSettingsPage from "pages/Hiring/EmployerSettingsPage";
import EditPositionListingPage from "pages/Hiring/EditPositionListingPage";
import CreatePosition from "pages/Hiring/CreatePosition";
import PostJobWorkflow from "pages/Hiring/PostJobWorkflow";
import ConfirmMeeting from "pages/Meeting/ConfirmMeeting";
import DeclineMeeting from "pages/Meeting/DeclineMeeting";
import MeetingSuccess from "pages/Hiring/MeetingSuccess";
import CompanyListing from "pages/ApplyForWork/CompanyListing";
import TermsOfServicePage from "pages/TermsOfServicePage";
import PrivacyPolicyPage from "pages/PrivacyPolicyPage";
import ContactUsPage from "pages/ContactUsPage";
import ConfirmActive from "pages/Applicant/ConfirmActive";
import SetInactive from "pages/Applicant/SetInactive";
import ApplyPage from "pages/ApplyForWork/Apply";

const AppRoutes: React.FC = () => {
  usePageTracking();
  const location = useLocation();
  const token = localStorage.getItem("adminToken");

  const isAuthenticated = () => {
    return token ? true : false;
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  const PrivateRoute: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/admin" />;
  }
  return <>{children}</>;
};

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/thank-you" element={<Layout showHeader={false} showFooter={false}><ThankYou /></Layout>} />
      <Route path="/payment-method" element={<Layout showHeader={false} showFooter={false}><PaymentMethod /></Layout>} />
      <Route path="/submission-complete" element={<Layout showHeader={false} showFooter={false}><SubmissionComplete /></Layout>} />

      <Route path="/auth/signup" element={<Layout showHeader={false} showFooter={false}><SignUpPage /></Layout>} />
      <Route path="/auth/signin" element={<Layout showHeader={false} showFooter={false}><SignInPage /></Layout>} />
      <Route path="/auth/otp" element={<Layout showHeader={false} showFooter={false}><PhoneVerification /></Layout>} />

      <Route path="/hiring/pricing" element={<Layout><PricingPage /></Layout>} />
      <Route path="/hiring/payment" element={<Layout><PaymentPage /></Layout>} />
      <Route path="/hiring/candidates" element={<Layout><Candidates /></Layout>} />
      <Route path="/hiring/candidates/selected" element={<Layout><CandidatesSelected /></Layout>} />
      <Route path="/hiring/meetings" element={<Layout><MeetingListPage /></Layout>} />
      <Route path="/hiring/meetings/new" element={<Layout><MeetingWorkflow /></Layout>} />
      <Route path="/hiring/meetings/save" element={<Layout><PersistMeeting /></Layout>} />
      <Route path="/hiring/meetings/:meetingId/success" element={<Layout><MeetingSuccess /></Layout>} />
      <Route path="/hiring/positions" element={<Layout><PositionsPage /></Layout>} />
      <Route path="/hiring/positions/new" element={<Layout><CreatePosition /></Layout>} />
      <Route path="/hiring/post-job-workflow" element={<Layout><PostJobWorkflow /></Layout>} />
      <Route path="/hiring/settings" element={<Layout><EmployerSettingsPage /></Layout>} />
      <Route path="/hiring/:company/:position" element={<Layout><PositionListing /></Layout>} />
      <Route path="/hiring/:employer_slug/:position_slug/edit" element={<Layout><EditPositionListingPage /></Layout>} />
      
      <Route path="/admin" element={<Layout>{isAuthenticated() ? <Navigate to="/admin/dashboard" /> : <AdminLogin />}</Layout>} />
      <Route path="/admin/dashboard" element={<Layout><PrivateRoute><AdminDashboard /></PrivateRoute></Layout>} />
      <Route path="/admin/applicants" element={<Layout><PrivateRoute><Applicants /></PrivateRoute></Layout>} />
      <Route
        path="/admin/applicants/:id"
        element={<Layout><PrivateRoute><ApplicantProfilePage /></PrivateRoute></Layout>}
      />

      <Route path="/apply" element={<Layout><ApplyPage /></Layout>} />
      <Route path="/apply/:company/:position" element={<Layout><PositionListing /></Layout>} />
      <Route path="/apply/:company" element={<Layout><CompanyListing /></Layout>} />
      <Route path="/apply/record" element={<RecordVideo />} />
      <Route path="/apply/review" element={<Layout showHeader={false} showFooter={false}><UploadVideo /></Layout>} />

      <Route path="/confirm-meeting/:applicant_meeting_id" element={<Layout><ConfirmMeeting /></Layout>} />
      <Route path="/decline-meeting/:applicant_meeting_id" element={<Layout><DeclineMeeting /></Layout>} />
      
      {/* Person Status Pages */}
      <Route path="/applicants/:applicant_id/confirm-active" element={<Layout showHeader={false} showFooter={false}><ConfirmActive /></Layout>} />
      <Route path="/applicants/:applicant_id/set-inactive" element={<Layout showHeader={false} showFooter={false}><SetInactive /></Layout>} />
      
      {/* Legal Pages */}
      <Route path="/terms" element={<Layout><TermsOfServicePage /></Layout>} />
      <Route path="/privacy" element={<Layout><PrivacyPolicyPage /></Layout>} />
      <Route path="/contact" element={<Layout><ContactUsPage /></Layout>} />
    </Routes>
  );
};

export default AppRoutes;
